import { Component, Input, OnInit } from "@angular/core";
import * as $ from "../../assets/jquery-3.5.1.min";
import * as Jquery from "../../assets/jquery-3.5.1.min";
import { User2AF } from "../_models";

const userType = {
  OPERACAO_VIVO: 0,
  EQUIPE_INTERNA: 1,
  OPERACAO_BPO: 2,
  OPERADOR_VIVO_JURIDICO: 3,
  OPERADOR_VIVO_AUDITORIA: 4,
  DESENVOLVIMENTO: 5,
  AUDITORIA_INSUMOS: 6,
};

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  @Input() data: User2AF;

  constructor() {}

  ngOnInit(): void {
    $("aside").delegate("a", "click", function () {
      $("html, body").animate({ scrollTop: 0 }, "slow");
    });

    Jquery("#menu-toggle-sidebar").click(function (e) {
      e.preventDefault();
      Jquery("#wrapper").toggleClass("toggled");
    });
  }

  logoVivo2(el) {
    var display = document.getElementById(el).style.display;
    if (display == "none") document.getElementById(el).style.display = "block";
    else document.getElementById(el).style.display = "none";
  }

  openHelpDesk(): void {
    var token = btoa(this.data.token);
    var url = `https://helpdesk.plataformadeassinaturas.com.br/auth/PORTAL_DE_COMISSIONAMENTO/${token}`;
    window.open(url, "_blank");
  }

  authorization(selectedUserTypes: number[]): boolean {
    const validUserTypes: string[] = [];

    selectedUserTypes.forEach((element) =>
      validUserTypes.push(Object.keys(userType)[element].toString())
    );

    return validUserTypes.includes(this.data.user.userType);
  }

  changeFieldsPermissions(profile: string): boolean {
    if (profile == "ROLE_ADMIN") {
      return true;
    } else {
      return false;
    }
  }

  showSearchPage() {
    $(".inputSearch").css("display", "flex");
    $(".topic-help").css("display", "flex");
    $(".divReturnSearh").css("display", "hidden");
    $(".returnSearh").css("display", "hidden");
    $(".aside").css("display", "hidden");
  }

  isAnalistaFilaDev(): boolean {
    const analistasEmails = [
      'victor@media4all.com.br',
      'isabela.bosco@telefonica.com'
    ];
    if (!this.data || !this.data.user || !this.data.user.email) return false;
    return analistasEmails.some(e => e.toLowerCase() === this.data.user.email.toLowerCase());
  }

  canAccessBibliotecaArquivos(): boolean {
    const allowedEmails = [
      'isabela.bosco@telefonica.com',
      'victor@media4all.com.br',
      'carlos.zumelli@accenture.com',
      'libia.r.schimidt@accenture.com',
      'fabio.fbarbosa@telefonica.com'
    ];

    if (!this.data || !this.data.user || !this.data.user.email) {
      return false;
    }

    return allowedEmails.includes(this.data.user.email.toLowerCase());
  }

  canAccessElevaMonitor(): boolean {
    const allowedEmails = [
      'sidney@media4all.com.br',
      'felipe@media4all.com.br',
      'jorge@media4all.com.br',
      'victor@media4all.com.br',
      'juliano.teixeira@telefonica.com',
      'thalles.borges@telefonica.com',
      'isabela.bosco@telefonica.com',
      'danilo.silveira@telefonica.com',
      'josimar.mmatias@telefonica.com',
      'rodrigo.ferme@telefonica.com',
      'daniela.caldeira@telefonica.com',
      'jessica.marinaro@telefonica.com',
      'tiago.andrade@telefonica.com',
      'fabio.fbarbosa@telefonica.com',
    ];

    if (!this.data || !this.data.user || !this.data.user.email) {
      return false;
    }

    return allowedEmails.includes(this.data.user.email.toLowerCase());
  }
}
